import { ValidHeimspielWorldCupProps } from './types'

const isValidHeimspielWorldCupProps = (
  props: any,
): props is ValidHeimspielWorldCupProps => !!props?.matchId

export { isValidHeimspielWorldCupProps }
